import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { medicalGroupsFeatureKey } from '../key';
import type { MedicalGroupsQueryFilter, MedicalGroupsQuerySorter } from './useMedicalGroupsInfiniteQuery';

type MedicalGroupListQueryType = GenericListQueryKey<MedicalGroupsQueryFilter, MedicalGroupsQuerySorter>;

export const getMedicalGroupsListQueryKey = (params: MedicalGroupListQueryType) =>
  generateListQueryKey({
    prefix: medicalGroupsFeatureKey,
  })(params);

export const getMedicalGroupsInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getMedicalGroupsListQueryKey,
});
